module.exports = __webpack_public_path__ + "static/home-ferry-d4485bf9130b2c94c56df32d0c716905.png";